<app-warranty-general-inputs  (partSelected)="partSelected($event)" (bicycleSelected)="bicycleSelected($event)" [type]="'callback'" [tabSelected]="tabSelected" [currentArticle]="currentArticle" [formGroup]="formGroup">
</app-warranty-general-inputs>
@if (formGroup.get('articleCode').value) {
  <app-warranty-guarantee-date [warrantyId]="0" [bicycleUnknown]="bicycleUnknown" [tabSelected]="tabSelected"
    [formGroup]="formGroup" [framenumber]="formGroup.get('framenumber').value"
    [articleCode]="formGroup.get('articleCode').value"
  ></app-warranty-guarantee-date>
}
